<template>
  <div>
    <div class="mapTool">
      地址：{{ mapInfo.address }}，经度：{{ mapInfo.lng }}，纬度：{{
        mapInfo.lat
      }}
    </div>
    <div
      class="amap-page-container"
      :style="{ width: '100%', height: heightMap + 'px' }"
    >
      <el-amap-search-box
        class="search-box"
        :search-option="searchOption"
        :on-search-result="onSearchResult"
      ></el-amap-search-box>
      <el-amap
        vid="amapDemo"
        :center="mapInfo.lnglat"
        :amap-manager="amapManager"
        :zoom="zoom"
        :events="events"
        class="amap-demo"
        style="height: 400px"
      >
        <el-amap-marker
          ref="marker"
          vid="component-marker"
          :position="mapInfo.lnglat"
        ></el-amap-marker>
      </el-amap>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
      style="text-align: center; margin-top: 20px;"
    >
      <el-button @click="clear">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </div>
</template>

<style>
.amap-demo {
  height: 300px;
}
</style>

<script>
import utils from "@/utils.js";
import VueAMap from "vue-amap";
import { AMapManager } from "vue-amap";
VueAMap.initAMapApiLoader({
  // 高德的key
  key: "1f8f479e9b787974efaa9bda1bf8ef92",
  // 插件集合
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geolocation"
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: "1.4.4"
});
const amapManager = new AMapManager();
export default {
  props: ["heightMap", "addressMap"],
  data: function() {
    return {
      searchOption: {
        //poi搜索条件  默认全国
        city: "全国",
        citylimit: false //是否限制城市内搜索
      },
      mapInfo: {
        //初始值默认为钻石广场
        address: "江苏省苏州市虎丘区钻石广场南楼502室",
        lng: 120.559812,
        lat: 31.285985,
        lnglat: [120.559812, 31.285985]
      },
      zoom: 12,
      amapManager,
      events: {
        click: e => {
          this.mapInfo.lng = e.lnglat.lng;
          this.mapInfo.lat = e.lnglat.lat;
          this.mapInfo.lnglat = [e.lnglat.lng, e.lnglat.lat];
          this.getFormattedAddress();
        }
      }
    };
  },

  methods: {
    clear() {
      this.$parent.$emit("closemap");
    },
    submit() {
      const pois = this.mapInfo;
      //判断地图返回的地址是否有绑定的字段
      let subIndexl = null;
      if (this.addressMap) {
        //是子表字段则给子表字段赋值 subIndex为第几条子表数据
        if (this.$el) {
          subIndexl = utils.getSomeAttributeFromParentElement(
            this.$el,
            "data-index"
          );
        }
      }
      const pInst = utils.getOnlineFormInstance(this);
      //赋值给绑定的字段
      utils.setValueByPath(
        pInst,
        this.addressMap,
        this.mapInfo.address,
        subIndexl
      );
      const ac = this.addressMap.split(".");
      let maxStr = "";
      if (ac.length > 0) {
        for (const i in ac) {
          if (i < this.addressMap.split(".").length - 1) {
            maxStr = maxStr ? maxStr + "." + ac[i] : maxStr + ac[i];
          }
        }
      }
      utils.setValueByPath(
        pInst,
        maxStr + ".longitude",
        this.mapInfo.lng,
        subIndexl
      );
      utils.setValueByPath(
        pInst,
        maxStr + ".latitude",
        this.mapInfo.lat,
        subIndexl
      );
      this.$parent.$emit("closemap");
    },
    onSearchResult(pois) {
      if (pois.length > 0) {
        //获取选择的地址经纬度
        this.mapInfo.lng = pois[0].lng;
        this.mapInfo.lat = pois[0].lat;
        this.mapInfo.lnglat = [pois[0].lng, pois[0].lat];
        this.getFormattedAddress();
      }
    },
    getFormattedAddress(map) {
      AMap.plugin("AMap.Geocoder", () => {
        let GeocoderOptions = {
          city: "全国"
        };
        let geocoder = new AMap.Geocoder(GeocoderOptions);
        if (!map) {
          geocoder.getAddress(this.mapInfo.lnglat, (status, result) => {
            if (status === "complete" && result.info === "OK") {
              this.mapInfo.address = result.regeocode.formattedAddress;
            } else {
              this.mapInfo.address = "无法获取地址";
            }
          });
        } else {
          const _this = this;
          geocoder.getLocation(_this.mapInfo.address, function(status, result) {
            if (status === "complete" && result.info === "OK") {
              const lnglat = result.geocodes[0].location;
              _this.mapInfo.lng = lnglat.lng;
              _this.mapInfo.lat = lnglat.lat;
              _this.mapInfo.lnglat = [lnglat.lng, lnglat.lat];
            }
          });
        }
      });
    },
    initMapByInput() {
      AMap.plugin("AMap.Autocomplete", () => {
        let autoOptions = {
          city: "全国",
          input: "tipinput"
        };
        let autoComplete = new AMap.Autocomplete(autoOptions);
        AMap.event.addListener(autoComplete, "select", e => {
          this.mapInfo.lat = e.poi.location.lat;
          this.mapInfo.lng = e.poi.location.lng;
          this.mapInfo.lnglat = [e.poi.location.lng, e.poi.location.lat];
        });
      });
    }
  },
  mounted() {
    //判断地图返回的地址是否有绑定的字段
    if (this.addressMap) {
      //是子表字段则获取子表字段值 subIndex为第几条子表数据
      let subIndex = null;
      if (this.$el) {
        subIndex = utils.getSomeAttributeFromParentElement(
          this.$el,
          "data-index"
        );
      }
      const pInst = utils.getOnlineFormInstance(this);
      //获取绑定字段的值
      if (utils.getValueByPath(pInst, this.addressMap, subIndex)) {
        this.mapInfo.address = utils.getValueByPath(
          pInst,
          this.addressMap,
          subIndex
        );
      }
      const ac = this.addressMap.split(".");
      let maxStr1 = "";
      if (ac.length > 0) {
        for (const i in ac) {
          if (i < this.addressMap.split(".").length - 1) {
            maxStr1 = maxStr1 ? maxStr1 + "." + ac[i] : maxStr1 + ac[i];
          }
        }
      }
      if (utils.getValueByPath(pInst, maxStr1 + ".longitude", subIndex)) {
        this.mapInfo.lng = utils.getValueByPath(
          pInst,
          maxStr1 + ".longitude",
          subIndex
        );
      } else {
        if (this.mapInfo.address != "江苏省苏州市虎丘区钻石广场南楼502室") {
          this.mapInfo.lng = "";
        }
      }
      if (utils.getValueByPath(pInst, maxStr1 + ".latitude", subIndex)) {
        this.mapInfo.lat = utils.getValueByPath(
          pInst,
          maxStr1 + ".latitude",
          subIndex
        );
      } else {
        if (this.mapInfo.address != "江苏省苏州市虎丘区钻石广场南楼502室") {
          this.mapInfo.lat = "";
        }
      }
      if (!this.mapInfo.lat && !this.mapInfo.lng) {
        this.getFormattedAddress(1);
      } else if (this.mapInfo.lat && this.mapInfo.lng) {
        this.mapInfo.lnglat = [this.mapInfo.lng, this.mapInfo.lat];
      }
    }
  }
};
</script>
<style>
#tipinput {
  margin-bottom: 10px;
}
.search-box {
  position: absolute !important;
  top: 10px;
  right: 10px;
}
.amap-page-container {
  position: relative;
}
.el-vue-search-box-container .search-tips {
  position: absolute;
  top: 100%;
  max-height: 280px;
  border: 0 !important;
  background: #fff;
  overflow: auto;
}
.el-vue-search-box-container .search-tips ul li {
  height: 40px;
  line-height: 40px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 10%);
  padding: 0;
  cursor: pointer;
  white-space: nowrap;
  width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mapTool {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
